export default __webpack_public_path__ + "static/media/helmet.cacd0326.svg";